import { AnyAction } from 'redux';
import {
  GlobalActions,
  TARIF_CHECKED,
  VereinbarungenChanged,
  VorbelegungPayload,
} from '@ps20-frontend/shop-integration-redux';
import cloneDeep from 'lodash/cloneDeep';
import {
  App,
  determineLaufzeit,
  getVetragsOptionenFromVorvertrag,
  VhvVorbelegungdaten,
} from '@ps20-frontend/frontend-models';
import { Produktlinienname } from '@ps20/bff-models';
import { addVorvertragToAngeboteReducer, vertragsoptionenReducer } from '@ps20-frontend/reducers';
import {
  VersicherungssummeChangedAction,
  VersicherungssummeEnum,
  VertragsoptionenVHV,
} from '../model/vertragsoptionen.model';
import { VersicherungssummenResponseReceived } from '../action-types/versicherungssummenResponseReceived';
import { IAppState } from '../appState';
import { VhvActions } from '../vhvActions';
import {
  selectSelectedProduktlinie,
  selectVertragsoptionSelectedProduktlinie,
} from '../../app/shared/selectors/produkt.selector';

export const vhvVertragsoptionReducer = function (
  sectionState: VertragsoptionenVHV = null,
  action: AnyAction,
  state: IAppState,
): VertragsoptionenVHV {
  sectionState = vertragsoptionenReducer(
    sectionState,
    action,
    App.VHV_V2,
    state,
  ) as VertragsoptionenVHV;
  switch (action.type) {
    case VhvActions.SELBSTBETEILIGUNG_CHANGED: {
      return {
        ...sectionState,
        selbstbeteiligung: action.payload.selbstbeteiligung,
      };
    }
    case VhvActions.VERSICHERUNGSSUMME_CHANGED: {
      const changeAction: VersicherungssummeChangedAction = action;
      return {
        ...sectionState,
        versicherungssumme: changeAction.payload.versicherungssumme,
      };
    }
    case VhvActions.PRODUKTLINIEN_CHANGED: {
      if (state?.vertragsoptionen?.versicherungssummeArt === VersicherungssummeEnum.INDV_VERSSUMME) {
        return sectionState;
      }
      const selectedProduktlinie =
        selectVertragsoptionSelectedProduktlinie(state)?.versicherungssumme;
      return {
        ...sectionState,
        versicherungssumme: selectedProduktlinie || sectionState.versicherungssumme,
      };
    }
    case VhvActions.VERSICHERUNGSSUMMEN_RESPONSE_RECEIVED: {
      if (
        state?.vertragsoptionen?.versicherungssummeArt === VersicherungssummeEnum.INDV_VERSSUMME
      ) {
        return sectionState;
      }
      const changeAction: VersicherungssummenResponseReceived = action.payload;
      const selectedProduktlinieName =
        selectSelectedProduktlinie(state)?.produktName ?? Produktlinienname.BASIS;
      const versicherungssumme =
        changeAction.summen.find(elem => elem.produktlinie === selectedProduktlinieName)?.summe ??
        changeAction.summen.find(elem => elem.produktlinie === Produktlinienname.BASIS).summe;
      return { ...sectionState, versicherungssumme };
    }
    case VhvActions.VERSSUMME_ART_CHANGED: {
      return {
        ...sectionState,
        versicherungssummeArt: action.payload.verssummeArt,
      };
    }
    case VhvActions.WOHNFLAECHE_CHANGED: {
      return {
        ...sectionState,
        versicherungssummeArt: VersicherungssummeEnum.EMPFOHLEN_VERSSUMME,
        versicherungssumme: null,
      };
    }
    case TARIF_CHECKED: {
      const newState: VertragsoptionenVHV = cloneDeep(sectionState);
      determineLaufzeit(action, newState, state.produkt, sectionState);
      return newState;
    }
    case GlobalActions.ADD_VORVERTRAG_TO_ANGEBOTE: {
      return addVorvertragToAngeboteReducer(
        sectionState,
        action,
        App.VHV_V2,
        state.angebotsId,
      ) as VertragsoptionenVHV;
    }
    case GlobalActions.VEREINBARUNGEN_CHANGED: {
      const newState: VertragsoptionenVHV = cloneDeep(sectionState);
      const actionPayload: VereinbarungenChanged = action.payload;
      const kuendigungenPayload = actionPayload.kuendingungChanged.some(elem => {
        return elem.appId === App.VHV_V2 && elem.angebotsId === state.angebotsId;
      });
      if (kuendigungenPayload) {
        newState.vorvertragGekuendigt = true;
      }
      return newState;
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: VhvVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.VHV_V2 && actionPayload.angebotsId === state.angebotsId) {
        const newState: VertragsoptionenVHV = getVetragsOptionenFromVorvertrag(
          sectionState,
          actionPayload,
        ) as VertragsoptionenVHV;
        newState.versicherungssumme = actionPayload.versicherungssumme;
        return { ...newState };
      }
      return sectionState;
    }
    case GlobalActions.VORBELEGUNG_FINISHED: {
      const actionPayload: VorbelegungPayload = action.payload;
      const { appId, angebotsId } = actionPayload;
      if (appId === App.VHV_V2 && angebotsId === state.angebotsId) {
        const vhvVorbelegungdaten: VhvVorbelegungdaten =
          actionPayload.vorhandeneVorbelegungdaten as VhvVorbelegungdaten;
        return {
          ...sectionState,
          urbeginn: vhvVorbelegungdaten.urbeginn,
        };
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
